import PropTypes from 'prop-types';
import React from 'react';

import { Color, colorList, ComponentSize } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../../utils/styles';

import './icon.scss';

export const iconSizeList: ComponentSize[] = [
  'xxxsmall',
  'xxsmall',
  'xsmall',
  'small',
  'medium',
  'large',
  'xlarge',
  'xxlarge',
];

export type VerticalAlign = 'top' | 'middle' | 'bottom';
export const verticalAlignList: VerticalAlign[] = ['top', 'middle', 'bottom'];

export interface IIcon extends IComponent {
  svg?: Function;
  reverse?: Boolean;
  verticalAlign?: VerticalAlign;
}

const sizes: { [key: string]: any } = Object.freeze({
  xxxsmall: 8,
  xxsmall: 14,
  xsmall: 20,
  small: 30,
  medium: 60,
  large: 80,
  xlarge: 100,
  xxlarge: 150,
});

const classNames = (
  color: Color,
  size: ComponentSize,
  verticalAlign: VerticalAlign | undefined,
  reverse: boolean | Boolean
): IClassNames =>
  makeClassNames({
    icon: [
      `icon icon--c-${color} icon--${size}`,
      verticalAlign && `icon--align-${verticalAlign}`,
      reverse && 'icon--reverse',
    ],
  });

const Icon: React.FC<IIcon> = ({
  color = 'inherit',
  size = 'xsmall',
  svg = () => {},
  reverse = false,
  verticalAlign,
}) => {
  const cn = classNames(color, size, verticalAlign, reverse);

  return (
    <i className={cn.icon}>
      {svg({
        width: sizes[size],
        height: sizes[size],
      })}
    </i>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Icon.propTypes = {
    color: PropTypes.oneOf<Color>(colorList),
    reverse: PropTypes.bool,
    size: PropTypes.oneOf(iconSizeList),
    svg: PropTypes.func,
    verticalAlign: PropTypes.oneOf(verticalAlignList),
  };
}

export default Icon;
